export default function script_fadeinLeft() {
    $(function(){
        $(window).scroll(function (){
            $('.fadeinLeft').each(function(){
                var elemPos = $(this).offset().top,
                    scroll = $(window).scrollTop(),
                    windowHeight = $(window).height(),
                    switchPoint = 601;
    
                // pcの場合のみ作動
                if(window.innerWidth < switchPoint){   //モバイルの場合
                  // if (scroll > elemPos - windowHeight + 10){
                  //     $(this).addClass('scrollin');
                  // }
                } else {   //pcの場合
                  if (scroll > elemPos - windowHeight + 200){
                      $(this).addClass('scrollin');
                  }
                }
            });
        });
    });
}
